module.exports = {"closeButtonText":"Cerrar","thumbNailAlt":"Vista previa de la imagen","next":"Página siguiente","previous":"Página anterior","addNote":"Agregar una nota..."}


//////////////////
// WEBPACK FOOTER
// ./translations/es-CO.json
// module id = 30
// module chunks = 0